import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { HarvestEventsProps } from 'services/harvestEvents/types';

// Global Components
import StatusIcon from 'components/StatusIcon';
import HarvestEventAssignedGroupsList from 'components/HarvestEventAssignedGroupsList';

// Global Selectors
import { makeSelectHarvestEventHasMultipleGroups } from 'services/harvestEvents/selectors';

interface OwnProps extends HarvestEventsProps {
    withText?: boolean;
}

interface ConnectedProps {
    hasMultipleGroups?: boolean;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventMultipleGroupsStatusComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { harvestEventUuid, hasMultipleGroups, withText } = this.props;
        if (hasMultipleGroups) {
            return (
                <StatusIcon
                    status="MULTIPLE_GROUPS"
                    withText={withText}
                    popupContent={
                        <HarvestEventAssignedGroupsList
                            harvestEventUuid={harvestEventUuid}
                        />
                    }
                />
            );
        }
        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    hasMultipleGroups: makeSelectHarvestEventHasMultipleGroups()
});

export default connect(mapStateToProps)(
    HarvestEventMultipleGroupsStatusComponent
);
